import request from '@/utils/request'

// 取得 Authorization
export function register(data) {
  return request({
    url: '/Member/register',
    method: 'post',
    data: {
      Data: data
    }
  })
}

// 取得 Authorization
export function login(username, password) {
  return request({
    url: '/Member/login',
    method: 'post',
    data: {
      Data: {
        username,
        password
      }
    }
  })
}

// 取得 Authorization
export function info(data) {
  return request({
    url: '/Member/info',
    method: 'post',
    data: {
      Data: data
    }
  })
}

// 取得 Authorization
export function subscribe(data) {
  return request({
    url: '/Member/subscribe',
    method: 'post',
    data: {
      Data: data
    }
  })
}

// 取得 Authorization
export function unsubscribe(data) {
  return request({
    url: '/Member/unsubscribe',
    method: 'post',
    data: {
      Data: data
    }
  })
}

// 取得 Authorization
export function emailVerify(data) {
  return request({
    url: '/Member/emailVerify',
    method: 'post',
    data: {
      Data: data
    }
  })
}

// 取得 Authorization
export function resendEmailVerify(data) {
  return request({
    url: '/Member/resend_emailVerify',
    method: 'post',
    data: {
      Data: data
    }
  })
}

// 取得 Authorization
export function forgotPassword(email) {
  return request({
    url: '/Member/forgotPassword',
    method: 'post',
    data: {
      Data: {
        email
      }
    }
  })
}


